import React, { useState, useEffect } from 'react'
import {
  Table,
  IconButton,
  Icon,
  Panel,
  ButtonGroup,
  Row,
  Col,
  Dropdown,
  SelectPicker,
  Input,
  Button,
} from 'rsuite'
import pathname from '../../constants/pathname'
import { useHistory } from 'react-router-dom'
import SearchButton from '../../components/buttons/searchButton/SearchButton'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../components/buttons/cancelButton/CancelButton'
import {
  sessionGetItemObj,
  sessionGetItemStr,
  sessionRemoveItem,
  sessionSetItemStr,
} from '../../utils/sessionHelpers'
import { budgetFormat } from '../../utils/formatterUtil'
import DatePickerCustom from '../../components/datePicker/DatePickerCustom'
import moment from 'moment'
import './styles_table.less'

export default function VoucherListTable({
  schema,
  dataKeyTable,
  pagination,
  onReload,
  loading,
  hiddenColStatus,
  onSearchCommittee,
  onEdit,
  onDownload,
  onDelete,
  expand: _expand,
  onSelect,
  onSearch,
  onCancel,
  onPreview,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table
  const history = useHistory()
  const [tableData, setTableData] = useState([])
  const [txtRecordTypeVal, setTxtRecordTypeVal] = useState(0)
  const [txtVoucherNumberVal, setTxtVoucherNumberVal] = useState('')
  const [txtActivityCodeVal, setTxtActivityCodeVal] = useState('')
  const [txtDescriptionVal, setTxtDescriptionVal] = useState('')
  const { periodNumber, startAndEndDate } = sessionGetItemObj('periodInfo')
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()

  useEffect(() => {
    setTableData(schema.values || [])
  }, [schema])

  const handleSearch = () => {
    // console.log('handleSearch ')
    onSearch(
      txtRecordTypeVal,
      txtVoucherNumberVal,
      txtActivityCodeVal,
      txtDescriptionVal,
      startDate,
      endDate
    )
  }

  const handleCancel = () => {
    setTxtRecordTypeVal(0)
    setTxtVoucherNumberVal('')
    setTxtActivityCodeVal('')
    setTxtDescriptionVal('')
    setStartDate('')
    setEndDate('')
    onCancel()
  }

  // console.log('tableData ', tableData)

  return (
    <>
      <Panel bordered header={'ค้นหา'} collapsible defaultExpanded>
        <div style={{ marginTop: -10, marginBottom: -10 }}>
          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.recordType.label}
              <SelectPicker
                searchable={false}
                value={txtRecordTypeVal}
                data={schema.recordType.options}
                block
                onChange={(value) => {
                  setTxtRecordTypeVal(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.voucherNumber.label}
              <Input
                value={txtVoucherNumberVal}
                onChange={(value) => {
                  setTxtVoucherNumberVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.activityCode.label}
              <Input
                value={txtActivityCodeVal}
                onChange={(value) => {
                  setTxtActivityCodeVal(value)
                }}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.description.label}
              <Input
                value={txtDescriptionVal}
                onChange={(value) => {
                  setTxtDescriptionVal(value)
                }}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.startDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={startDate}
                onChange={(value) => {
                  setStartDate(value)
                }}
                disabledDate={(date) => endDate && moment(endDate).isBefore(date, new Date())}
              />
            </Col>

            <Col lg={8} md={8} sm={24} xs={24}>
              {schema.endDate.label}
              <DatePickerCustom
                {...props}
                placement="auto"
                value={endDate}
                onChange={(value) => {
                  setEndDate(value)
                }}
                disabledDate={(date) => startDate && moment(startDate).isAfter(date, new Date())}
              />
            </Col>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
          </Row>

          <Row style={{ marginBottom: 10 }}>
            <Col lg={4} md={4} sm={24} xs={24}></Col>
            <Col lg={8} md={8} sm={24} xs={24}>
              <SearchButton disabled={false} onClick={handleSearch}>
                ค้นหา
              </SearchButton>
              {`  `}
              <CancelButton disabled={false} onClick={handleCancel}>
                ยกเลิก
              </CancelButton>
            </Col>
          </Row>
        </div>
      </Panel>

      <div style={{ marginTop: 20 }}>
        <Row>
          {schema?.isEnableEdit && (
            <Col lg={24} md={24} sm={24} xs={24} style={{ textAlign: 'right' }}>
              <SaveButton
                icon="plus-square"
                disabled={false}
                onClick={() => {
                  sessionRemoveItem('isViewOnly')
                  onSelect(null, 'Income')
                }}
                style={{
                  marginRight: 10,
                }}
              >
                เพิ่มบันทึกรับ
              </SaveButton>
              <CancelButton
                icon="minus-square"
                disabled={false}
                onClick={() => {
                  sessionRemoveItem('isViewOnly')
                  onSelect(null, 'Outcome')
                }}
                style={{
                  marginRight: 10,
                }}
              >
                เพิ่มบันทึกจ่าย
              </CancelButton>
            </Col>
          )}
        </Row>
      </div>

      <div className="table-affix-header">
        <Table
          wordWrap
          // height={350}
          // autoHeight={tableData.length < 10}
          minHeight={350}
          autoHeight
          loading={loading}
          data={tableData}
          style={{ marginTop: 10 }}
          rowClassName={(rowData) => (rowData && rowData.isSaveDraft ? 'saved-row' : '')}
          affixHeader
        >
          <Column width={90} align="center">
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>

          <Column width={90} align="center">
            <HeaderCell>ประเภท</HeaderCell>
            <Cell>
              {(rowdata) => {
                if (rowdata.type === 'Income') {
                  return <Icon icon="data-increase" style={{ color: 'green' }} />
                } else {
                  return <Icon icon="data-decrease" style={{ color: 'red' }} />
                }
              }}
            </Cell>
          </Column>

          <Column width={180}>
            <HeaderCell>วันที่เอกสาร</HeaderCell>
            <Cell dataKey="documentDate" />
          </Column>

          <Column width={180}>
            <HeaderCell>เลขที่ใบสำคัญ</HeaderCell>
            <Cell dataKey="voucherNumber" />
          </Column>

          <Column minWidth={300} width={420} flexGrow>
            <HeaderCell>คำอธิบายรายการ</HeaderCell>
            <Cell dataKey="description" />
          </Column>

          <Column width={180} align="right">
            <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
            {/* <Cell style={{ textAlign: 'right' }} dataKey="amount" /> */}
            <Cell>
              {(rowData) => {
                return budgetFormat(rowData.amount)
              }}
            </Cell>
          </Column>

          <Column width={180}>
            <HeaderCell>หมายเหตุ</HeaderCell>
            <Cell>
              {(rowData) => {
                return (
                  <>
                    {rowData.warning && (
                      <div style={{ color: rowData.warningColor }}>
                        <Icon icon="exclamation-circle" size="lg" style={{ marginRight: 10 }} />
                        <label style={{ fontSize: '0.75rem' }}>{rowData.warning}</label>
                      </div>
                    )}
                  </>
                )
              }}
            </Cell>
          </Column>

          <Column width={180} align="center">
            <HeaderCell>วันที่บันทึกรายการ</HeaderCell>
            <Cell dataKey="createDate" />
          </Column>

          <Column width={150} align="center" fixed="right">
            <HeaderCell>จัดการรายการ</HeaderCell>
            <Cell>
              {(rowData) => {
                // console.log('rowData ', rowData)
                // disabled={!rowData.pathFile} เช็คกรณีที่ pathFile = null
                return (
                  <>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-df"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-none-radius" />}
                        onClick={(e) => {
                          onSelect(rowData)
                          sessionSetItemStr('isViewOnly', 'isViewOnly')
                        }}
                      ></IconButton>
                      {schema?.isEnableEdit && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-edit"
                          size="sm"
                          icon={<Icon icon="edit" className="bt-gost-icon-none-radius-edit" />}
                          onClick={(e) => {
                            onSelect(rowData)
                            sessionRemoveItem('isViewOnly')
                          }}
                        ></IconButton>
                      )}
                      {!rowData.isSaveDraft && (
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-info"
                          size="sm"
                          //disabled={!rowData.pathFile}
                          icon={<Icon icon="print" className="bt-gost-icon-none-radius-info" />}
                          onClick={() => onPreview(rowData)}
                        ></IconButton>
                      )}
                    </ButtonGroup>
                  </>
                )
              }}
            </Cell>
          </Column>
        </Table>
      </div>
    </>
  )
}
